import PropTypes from 'prop-types';
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import { load } from '../../../reducers/projects/projects.actions';
import { loading, projects } from '../../../reducers/projects/projects.reducer';
import { Spinner } from '../../Spinner/Spinner';
import ConnectedProjectAssign from './ProjectAssign/ProjectAssign';
import './ProjectManagerProjects.css';

export class ProjectManagerProjects extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areProjectsLoading} />
        <ListGroup>
          {this.props.projects.map(project => (
            <ConnectedProjectAssign project={project} />
          ))}
        </ListGroup>
      </span>
    );
  }
}

ProjectManagerProjects.propTypes = {
  load: PropTypes.func.isRequired,
  areProjectsLoading: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areProjectsLoading: loading(state),
  projects: projects(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagerProjects);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/Projects/ProjectManagerProjects.jsx